export default "__VITE_ASSET__Bw945Ihh__"